module.exports = [
	{
		"id": "AL",
		"country": "Algeria",
		"name": "OFFICE LINE SARL",
		"address": "Zone d’activite lot no 41<br>Bordj Menaiel 35200<br>Boumerdes<br>Algeria",
		"telephone": [
			{
				"display": "+213 24 88 69 71",
				"link": "+213-24-88-69-71"
			}
		],
		"email": "info@officeline-dz.com",
		"fax": "+213 24 81 73 29"
	},
	{
		"id": "AN",
		"country": "Angola",
		"name": "NCR Angola Informática, Lda",
		"address": "Av. 19 Congresso<br>MPLA 7/9 Luanda",
		"telephone": [
			{
				"display": "+244222 638 600",
				"link": "+244-222-638-600"
			}
		],
		"email": "comercial@ncrangola.com",
		"fax": "+244222 330 537",
		"website": "http://www.ncrangola.com"
	},
	{
		"id": "ANP",
		"country": "Australia - New Zealand - Papua New Guinea - Fiji, Somoa - Tonga",
		"name": "Mayo Hardware Australia and New Zealand",
		"address": "4 Secombe Place<br>Moorebank NSW 2170<br>Australia",
		"telephone": [
			{
				"name": "Australia",
				"display": "1300 360 211",
				"link": "+61-1300-360-211"
			},
			{
				"name": "New Zealand",
				"display": "09 415 6240",
				"link": "+64-09-415-6240"
			}
		],
		"telephoneLink": "",
		"email": "customerservice@mayohardware.com.au",
		"website": "http://www.mayohardware.com.au/security"
	},
	{
		"id": "BAH",
		"country": "Bahrain",
		"name": "Manazel",
		"address": "P.O. BOX  NO : 10614<br> Building No: 174<br> Road No: 408,<br> Block No: 704<br> Manama",
		"telephone": [
			{
				"display": "+973-17786727",
				"link": "+973-177-8-6727"
			}
		],
		"email": "manazel@batelco.com.bh",
		"fax": "+973-17784611"
	},
	{
		"id": "BAH",
		"country": "Bahrain",
		"name": "Yaquby Stores W.L.L.",
		"address": "P.O.Box 158<br> Manama<br> Bahrain",
		"telephone": [
			{
				"display": "973 172 1 0959",
				"link": "+973-172-1-0959"
			}
		],
		"email": "mailbox@yaqubystores.com",
		"fax": "973 172 1 0953",
		"website": "http://www.yacubystores.com"
	},
	{
		"id": "CN",
		"country": "China",
		"name": "Sen Wai International Company Limited",
		"address": "Room B100, 3/F<br> No.108 Keyun North Road<br> Tianhe District<br> Guangzhou <br> China",
		"telephone": [
			{
				"display": "020-22278161",
				"link": "+020-22278161"
			}
		],
		"email": "support@gzzhanhao.com",
		"website": "http://www.senwai.com.hk/"
	},
	{
		"id": "CY",
		"country": "Cyprus",
		"name": "CTE Enterprises Co. Ltd.",
		"address": "P.O. Box 62106<br> 2, Ambelokipon St.<br> 8062 Paphos<br> Cyprus",
		"telephone": [
			{
				"display": "357 26 22 0222",
				"link": "+357-26-22-0222"
			}
		],
		"email": "chris5@cytanet.com.cy",
		"fax": "357 26 95 5225"
	},
	{
		"id": "EG",
		"country": "Egypt",
		"name": "SAMIR and ALY Stationery Houses and Co",
		"address": "64 Zaker Hussein Street<br> Nasr City<br> Cairo<br> Egypt",
		"telephone": [
			{
				"display": "+2 02 22627333",
				"link": "+20-2-22627333"
			},
			{
				"display": "+2 02 22622158",
				"link": "+20-2-22622158"
			},
			{
				"display": "+2 02 24010014",
				"link": "+20-2-24010014"
			}
		],
		"emailContact": "Mr. Walid Shatla",
		"email": "samiraly@samir-aly.com.eg",
		"fax": "+2 02 22635349"
	},
	{
		"id": "FR",
		"country": "France",
		"name": "Hartmann Tresore France",
		"address": "3, Rue de la Louvière<br>BP 77<br> 78512 Rambouillet Cedex",
		"telephone": [
			{
				"display": "01 34 57 11 55",
				"link": "+33-01-34-57-11-55"
			}
		],
		"email": "contact@sentrysafe.fr",
		"fax": "01 30 41 15 38"
	},
	{
		"id": "GR",
		"country": "Greece",
		"name": "Plaisio Computers S.A",
		"address": "Thesi Skliri<br>19600 Magoula Athens, Attica<br>Greece",
		"telephone": [
			{
				"name": "Plaisio Customer Service",
				"display": "0030 210 2892000",
				"link": "+30-210-2892000"
			}
		],
		"fax": "30 210 5587440",
		"website": "http://www.plaisio.gr"
	},
	{
		"id": "GM",
		"country": "Germany",
		"name": "WAGNER Sicherheitstechnik GmbH",
		"address": "Käthe-Kollwitz-Str. 3<br>97218 Würzburg/Gerbrunn<br>Deutschland",
		"telephone": [
			{
				"display": "0049 931 705 88 28",
				"link": "+49-931-705-88-28"
			}
		],
		"emailContact": "Marcel Badenheuer",
		"email": "m.badenheuer@wagner-sicherheit.de",
		"fax": "0049 931 705 88  88",
		"website": "http://www.wagner-sicherheit.de"
	},
	{
		"id": "HK",
		"country": "Hong Kong / Macau",
		"name": "Sen Wai International Company Limited",
		"address": "Flat A, G/F., Gee Chang Industrial Building,<br>108 Lok Shan Road,<br>Kowloon, Hong Kong",
		"telephone": [
			{
				"display": "2356 2028",
				"link": "+852-2356-2028"
			}
		],
		"email": "williamng@senwai.com.hk",
		"fax": "2356 2111",
		"website": "http://www.senwai.com.hk/"
	},
	{
		"id": "ID",
		"country": "Indonesia",
		"name": "Kawan Lama Internusa, PT",
		"address": "Gedung Kawan Lama<br>Jl. Puri Kencana No. 1<br>Jakarta 11610, Indonesia ",
		"telephone": [
			{
				"display": "+62 21 582 4002",
				"link": "+62-21-582-4002"
			}
		],
		"emailContact": "Eric Adi Saputra",
		"email": "ericadi@kawanlamainternusa.com",
		"fax": "+62 21 582 4020",
		"website": "http://www.kawanlamainternusa.com"
	},
	{
		"id": "IS",
		"country": "Israel",
		"name": "I. Berman Ltd.",
		"address": "11 Ha-Yarden Street<br>PO BOX 295<br>Yavne 81102<br>ISRAEL",
		"telephone": [
			{
				"display": "+972 8 942 9999",
				"link": "+972-8-942-9999"
			}
		],
		"email": "orenmoti@i-berman.co.il",
		"fax": "+972 8 942 9969"
	},
	{
		"id": "JP",
		"country": "Japan",
		"name": "Master Lock Sentry Japan Co., Ltd.",
		"address": "NMF Takanawa Bldg. 4F,2-20-4,<br>Higashigotanda<br>Shinagawa-ku, Tokyo<br>141-0022 Japan",
		"telephone": [
			{
				"display": "81-3-5447-5311",
				"link": "+81-3-5447-5311"
			}
		],
		"email": "web@mlsj.jp",
		"fax": "81-3-5447-5316",
		"website": "http://www.sentryjp.com"
	},
	{
		"id": "JD",
		"country": "Jordan",
		"name": "Midas Furniture LLC",
		"address": "Wasfi Al - Tal Str<br>Amman 11821<br>Jordan",
		"telephone": [
			{
				"display": "962 5522 686",
				"link": "+962-5522-686"
			}
		],
		"email": "",
		"fax": "962 5532 220",
		"website": "http://www.midasfurniture.com"
	},
	{
		"id": "KU",
		"country": "Kuwait",
		"name": "Midas Furniture LLC",
		"address": "P.O.Box 36303 Raas Al-Salmiya<br>24754 Kuwait<br>Kuwait",
		"telephone": [
			{
				"display": "965 2411 366",
				"link": "+965-2411-366"
			}
		],
		"email": "midas@midasfurniture.com",
		"fax": "965 2414 970",
		"website": "http://www.midasfurniture.com"
	},
	{
		"id": "LB",
		"country": "Lebanon",
		"name": "The Right Angle SAL",
		"address": "Boulos Bldg<br>Hazmieh-Damascus Highway<br> P.O. Box 165609<br> Beirut",
		"telephone": [
			{
				"display": "+961 5 952 102",
				"link": "+961-5-952-102"
			}
		],
		"email": "boulos.joe@gmail.com",
		"website": "http://www.homeandbeyond-lb.com"
	},
	{
		"id": "MR",
		"country": "Morocco",
		"name": "ETS Louis Guillad et Cie",
		"address": "31, rue Pierre Parent<br> Casablanca<br> Morocco",
		"telephone": [
			{
				"display": "212 22 30 59 71",
				"link": "+212-22-30-59-71"
			}
		],
		"email": "Azedine.Boumadiane@Elg.Co.Ma",
		"fax": "212 22 21 78 88"
	},
	{
		"id": "OM",
		"country": "Oman",
		"name": "Shah Nagardas Manji & Co.",
		"address": "P.O.Box 2908<br>Ruwi 112<br>Oman",
		"telephone": [
			{
				"display": "968 702 772",
				"link": "+968-702-772"
			}
		],
		"email": "snmanji@omantel.net.om",
		"fax": "968 797 227"
	},
	{
		"id": "PP",
		"country": "Philippines",
		"name": "Zenorex Marketing Corp.",
		"address": "25/F Cityland 10 Tower 1<br> Ayala Ave. / H.V. de la Costa<br> 1227 Makati City, Philippines",
		"telephone": [
			{
				"display": "+63 (2) 893 7610 to 12",
				"link": "+63-2-893-7610"
			}
		],
		"email": "zmc@zenorexmarketing.com",
		"fax": "+63 (2) 894 5618",
		"website": "http://www.zenorexmarketing.com"
	},
	{
		"id": "QR",
		"country": "Qatar",
		"name": "YAQUBY STORES CO W.L.L",
		"address": "P.O.Box 22824<br>Doha, State of Qatar<br> Salwa Road.(Alin Trading Complex 3)",
		"telephone": [
			{
				"display": "+9744688859",
				"link": "+9744688859"
			}
		],
		"email": "dohamail@yaqubystores.com",
		"fax": "+9744685554"
	},
	{
		"id": "RM",
		"country": "Rep. Of Maldives",
		"name": "ASTERS PVT LTD",
		"address": "H.Athirihura<br>Ameeru Ahmed Magu<br>Male' 20096",
		"telephone": [
			{
				"display": "+960 3346405",
				"link": "+960-3346405"
			}
		],
		"email": "thalhath@asters.com.mv",
		"fax": "+960 3346444"
	},
	{
		"id": "SAU",
		"country": "Saudia Arabia",
		"name": "Saudi Company For Hardware (SACO)",
		"address": "2nd Fl.  Takhassusi St.<br>P.O. Box 86387, Riyadh 11622<br>Kingdom of Saudi Arabia",
		"telephone": [
			{
				"display": "966 1 482 8877",
				"link": "+966-1-482-8877"
			}
		],
		"email": "sales@saco-ksa.com",
		"fax": "966 1 488 1920",
		"website": "http://www.saco.com.sa"
	},
	{
		"id": "SMB",
		"country": "Singapore, Malaysia and Brunei",
		"name": "Duro International Pte Ltd",
		"address": "61 Kaki Bukit Ave 1<br>#04-36 Shun Li Industrial Park<br>Singapore, 417943",
		"telephone": [
			{
				"display": "+65 (6745) 6800",
				"link": "+65-6745-6800"
			}
		],
		"email": "jon@duro.com.sg",
		"fax": "+65 (6745) 3900",
		"website": "http://www.duro.com.sg"
	},
	{
		"id": "TW",
		"country": "Taiwan",
		"name": "Shyh Ru Metallic Industrial Corp.",
		"address": "No. 1, Lane 721, Chung Cheng Road<br>Shin Chuang City, Tapei County<br>242 Taiwan",
		"telephone": [
			{
				"display": "886-2-29065816",
				"link": "+886-2-29065816"
			}
		],
		"email": "shyh.ru@msa.hinet.net",
		"fax": "886-2-29025877",
		"website": "http://www.shyhru.com.tw"
	},
	{
		"id": "TLM",
		"country": "Thailand, Laos & Myanmar",
		"name": "Naradee Trading Co., Ltd.",
		"address": "48/13 Soi Praditmanootham 19<br>Praditmanoothan Road, Ladprao District<br>Bangkok<br>10230 Thailand",
		"telephone": [
			{
				"display": "+66 (0) 2515 8981-3",
				"link": "+66-0-2515-8981-3"
			}
		],
		"email": "contact@naradee.com",
		"fax": "+66 (0) 2515 0229",
		"website": "http://www.naradee.com/shop/sentrysafe"
	},
	{
		"id": "UAE",
		"country": "UAE",
		"name": "AL Futtaim Trading",
		"address": "Ace Hardware<br>Festival City<br>Dubai UAE.",
		"telephone": [
			{
				"display": "800 275 223",
				"link": "+800-275-223"
			}
		],
		"email": "ace@alfuttaim.ae",
		"website": "https://www.aceuae.com/en-AE/our-brands/sentry/"
	},
	{
		"id": "UC",
		"country": "United States and Canada",
		"name": "Sentry Safe US and Canada",
		"telephone": [
			{
				"display": "800-828-1438",
				"link": "+800-828-1438"
			}
		],
		"fax": "414-766-6512",
		"website": "http://www.sentrysafe.com"
	},
	{
		"id": "VT",
		"country": "Vietnam",
		"name": "SEN WAI VIETNAM COMPANY LIMITED",
		"address": "8th Floor, Room 801, 50 Ton That Dam Street,<br>Ben Thanh Ward, Ho Chi Minh City<br>Vietnam",
		"telephone": [
			{
				"display": "+84 (798) 518 067",
				"link": "+84-(798)-518-067"
			}
		],
		"email": "support@senwai.com.vn",
		"website": "https://senwai.com.vn/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/pages/whereToBuy/addressData.json
// module id = 774
// module chunks = 0